import React from "react";
import { Row, Col, Form, Button, Modal, Dropdown } from "react-bootstrap";
import DataTable from "react-data-table-component";
import * as code from "./../../../config/Constants";
import * as message from "./../../../config/CommonMessages";
import { TextField, IconButton } from "@material-ui/core";
import {
  CheckCircle,
  CheckCircleOutline,
  Schedule,
  Edit,
} from "@material-ui/icons";
import { getBuyerTasksAction } from "./../../../actions/BuyerTransactionActions";
import { getAllTasksAction } from "./../../../actions/TransactionActions";
import { getVendorTasksAction } from "./../../../actions/VendorTransactionActions";
import {
  cryptoTokenDecode,
  toastMessage,
  convertTZ,
} from "../../Common/Common";
import TaskDetail from "../../Transactions/Detail/task-detail";
import { connect } from "react-redux";
import moment from "moment/moment";
import TaskAdd from "./task-add";
import { getallpermissions } from "../../../actions/UserActions";
import { REACT_APP_CRYPTO_SECRET_KEY } from "../../../config/Constants";
var CryptoJS = require("crypto-js");

// let userType = cryptoTokenDecode().usertype;
// let currentRole = cryptoTokenDecode().roleName
//   ? cryptoTokenDecode().roleName.toUpperCase()
//   : "";

const columns = [
  {
    name: "Title",
    selector: "title",
    sortable: true,
    width: "200px",
  },
  {
    name: "Date",
    selector: "date",
    sortable: true,
  },
  {
    name: "Duration",
    selector: "duration",
    sortable: true,
    width: "200px",
  },
  {
    name: "Status",
    selector: "status",
    right: true,
    center: true,
    width: "75px",
  },
  {
    name: "Edit",
    selector: "edit",
    center: true,
    right: true,
    width: "75px",
  },
  // {
  //     name: "",
  //     selector: "complete",
  //     right: true,
  //     ignoreRowClick: true,
  //     width: "75px"
  // }
];

const clientColumns = [
  {
    name: "Title",
    selector: "title",
    sortable: true,
  },
  {
    name: "Date",
    selector: "date",
    sortable: true,
  },
  {
    name: "Duration",
    selector: "duration",
    sortable: true,
  },
  {
    name: "Status",
    selector: "status",
    right: true,
    center: true,
    width: "75px",
  },
  // {
  //     name: "",
  //     selector: "complete",
  //     right: true,
  //     ignoreRowClick: true,
  //     width: "75px"
  // }
];

function Tasks({
  getAllTasksAction,
  getBuyerTasksAction,
  getVendorTasksAction,
  transactionId,
  transactionData,
  transactionStatus,
  vendorTasks,
  buyerTasks,
  getallpermissions,
}) {
  const [tasks, setTasks] = React.useState([]);
  const [taskId, setTaskId] = React.useState("");
  const [editTaskModalState, setEditTaskModalState] = React.useState("");
  const [showEditTaskModal, setShowEditTaskModal] = React.useState(false);
  const [addTaskModalState, setAddTaskModalState] = React.useState("");
  const [showAddTaskModal, setShowAddTaskModal] = React.useState(false);
  const [permissionArray, setPermissionArray] = React.useState([]);
  const [currentRole, setCurrentRole] = React.useState(
    cryptoTokenDecode().roleName
      ? cryptoTokenDecode().roleName.toUpperCase()
      : ""
  );
  const [userType, setUserType] = React.useState(cryptoTokenDecode().usertype);

  React.useEffect(() => {
    getAllTasks();
    getUserPermissions();
  }, []);

  const getUserPermissions = () => {
    let usertype = localStorage.getItem("usertype");
    if (usertype === "VENDOR") {
      getallpermissions().then((res) => {
        if (res.data) {
          localStorage.setItem("otherInfo", res.data);

          let bytes = CryptoJS.AES.decrypt(
            res.data,
            REACT_APP_CRYPTO_SECRET_KEY
          );
          let decryptedData = bytes.toString(CryptoJS.enc.Utf8);
          // console.log("Header ===> decryptedData39", decryptedData);
          let permissionarray = decryptedData.split(",");
          // console.log("Header ===> permissionarray", permissionarray);
          setPermissionArray(permissionarray);
        }
      });
    }
  };

  const checkPermission = (checkFor) => {
    const hasSome =
      permissionArray &&
      permissionArray.length > 0 &&
      checkFor.some((item) => permissionArray.includes(item));
    return hasSome;
  };

  function getAllTasks() {
    if (userType === message.VENDOR && currentRole === message.Artist) {
      getVendorTasksAction(transactionId).then((vendorTaskRes) => {
        setTasks(
          vendorTasks != null && vendorTasks != undefined
            ? vendorTasks.data
            : []
        );
      });
    } else if (userType === message.VENDOR || currentRole === message.BUYER) {
      getBuyerTasksAction(transactionId).then((buyerTaskRes) => {
        setTasks(
          buyerTasks != null && buyerTasks != undefined ? buyerTasks.data : []
        );
      });
    } else {
      getAllTasksAction(transactionId).then((taskRes) => {
        setTasks(taskRes.data.data);
      });
    }

    return tasks;
  }

  function handleOpenEditTask(eventTitle) {
    let id = "";
    let found = false;
    for (let i = 0; i < tasks.length; i++) {
      if (eventTitle === tasks[i].title) {
        id = tasks[i]._id;
        found = true;
        break;
      }
    }

    if (found) {
      setTaskId(id);

      if (window.innerWidth > 991) {
        setEditTaskModalState("open");
      } else {
        setShowEditTaskModal(true);
      }
    }
  }

  function handleCloseEditTask() {
    if (window.innerWidth > 991) {
      setEditTaskModalState("");
    } else {
      setShowEditTaskModal(false);
    }
  }

  function handleOpenAddTask() {
    if (window.innerWidth > 991) {
      setAddTaskModalState("open");
    } else {
      setShowAddTaskModal(true);
    }
  }

  function handleCloseAddTask() {
    if (window.innerWidth > 991) {
      setAddTaskModalState("");
    } else {
      setShowAddTaskModal(false);
    }
  }

  function updateTasksAfterEdit(name) {
    if (name === "update") {
      getAllTasks();
    } else {
      setEditTaskModalState("");
      setTaskId("");
    }
  }

  function updateTasksAfterAdd(name) {
    if (name === "update") {
      getAllTasks();
      handleCloseAddTask();
    }
    handleCloseAddTask();
  }

  let rows = [];
  for (let i = 0; i < tasks.length; i++) {
    let task = tasks[i];

    let taskObject = {
      id: task._id,
      transId: task.transactionId,
      title: task.title,
      date: moment(task.eventStartDate).format("MM/DD/YYYY"),
      // duration: task.specialTask.includes("Appointment")
      //   ? moment(task.eventStartDate).format("hh:mm a") +
      //     " - " +
      //     moment(task.eventEndDate).format("hh:mm a")
      //   : task.specialTask.includes("Paperwork")
      //   ? "N/A"
      //   : "",
      duration: task.specialTask.includes("Appointment")
        ? moment(
            convertTZ(task.eventStartDate, transactionData.userTimezone)
          ).format("hh:mm a") +
          " - " +
          moment(
            convertTZ(task.eventEndDate, transactionData.userTimezone)
          ).format("hh:mm a")
        : task.specialTask.includes("Paperwork")
        ? "N/A"
        : "",
      status:
        task.status === "SCHEDULED" ? (
          <Schedule style={{ color: "#0E9EEA" }} />
        ) : task.status === "COMPLETED" ? (
          <CheckCircle className="check" style={{ color: "green" }} />
        ) : (
          ""
        ),
      contingency: task.contingency,
      specialTask: task.specialTask,
      edit: (
        <IconButton onClick={() => handleOpenEditTask(task.title)}>
          <Edit />
        </IconButton>
      ),
      // complete: task.status === "SCHEDULED" ? <IconButton><CheckCircleOutline onClick={() => completeTask(task.title)}/></IconButton> : task.status === "COMPLETED" ? <IconButton><CheckCircle className='check' style={{ color: "green" }}/></IconButton> : ''
    };

    rows.push(taskObject);
  }

  return (
    <div>
      <Row className="mt-2 align-items-center conti-title">
        <Col className="col-auto pr-0">
          <h2 className="color-black font-20 mb-0">Important Things</h2>
        </Col>

        {currentRole === message.BUYER ||
        (userType === message.VENDOR &&
          currentRole == message.Artist &&
          !checkPermission([message.manage_transactions])) ||
        (transactionData && transactionStatus === "COMPLETED") ? (
          ""
        ) : (
          <Col align="right" className="pl-0">
            <Button
              variant="primary"
              className="btn-blue text-uppercase add-vendor-btn"
              onClick={() => {
                // if (localStorage.getItem("isActive") === false) {
                //     toastMessage(code.ERROR, message.SUBSCRIPTION_NOT_ACTIVE);
                // } else {
                //     handleOpenAddTask();
                // }

                handleOpenAddTask();
              }}
            >
              Add Task
            </Button>
          </Col>
        )}
      </Row>
      <DataTable
        columns={
          userType === message.VENDOR && currentRole === message.BUYER
            ? clientColumns
            : columns
        }
        data={rows.filter(
          (rows) =>
            rows.specialTask.includes("Appointment") ||
            rows.specialTask.includes("Paperwork")
        )}
        pagination
      />

      <Modal
        show={
          window.innerWidth > 991
            ? editTaskModalState === "open"
            : showEditTaskModal
        }
        onHide={() => handleCloseEditTask()}
        dialogClassName="modal-90w"
        className={
          window.innerWidth > 800
            ? "modal-med modal-view-page task-mobile-modal"
            : "modal-med modal-view-page task-mobile-modal-overview"
        }
        style={
          window.innerWidth > 991
            ? { transform: "translate(-150px, 50px)" }
            : {}
        }
      >
        {window.innerWidth > 991 ? "" : <Modal.Header closeButton />}
        <Modal.Body
          className={
            window.innerWidth > 991
              ? editTaskModalState + " task-single calendar-add-task"
              : ""
          }
        >
          <TaskDetail
            taskId={taskId}
            transactionData={transactionData}
            onUpdate={(e) => updateTasksAfterEdit(e)}
            permissiontype={message.manage_transactions}
          />
        </Modal.Body>
      </Modal>

      <Modal
        show={
          window.innerWidth > 991
            ? addTaskModalState === "open"
            : showAddTaskModal
        }
        onHide={() => handleCloseAddTask()}
        dialogClassName="modal-90w"
        className={
          window.innerWidth > 800
            ? "modal-med modal-view-page task-mobile-modal"
            : "modal-med modal-view-page task-mobile-modal-overview"
        }
        style={
          window.innerWidth > 991
            ? { transform: "translate(-150px, 50px)" }
            : {}
        }
      >
        {window.innerWidth > 991 ? "" : <Modal.Header closeButton />}
        <Modal.Body
          className={
            window.innerWidth > 991
              ? addTaskModalState + " task-single calendar-add-task"
              : ""
          }
        >
          <TaskAdd
            taskId={taskId}
            transactionData={transactionData}
            onUpdate={(e) => updateTasksAfterAdd(e)}
          />
        </Modal.Body>
      </Modal>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    tasks: state.reducer.tasks,
    vendorTasks: state.reducer.vendorTasks,
    buyerTasks: state.reducer.buyerTasks,
  };
};

export default connect(mapStateToProps, {
  getAllTasksAction,
  getVendorTasksAction,
  getBuyerTasksAction,
  getallpermissions,
})(Tasks);
